import { Component } from '@angular/core';

@Component({
    selector: 'app-root-component',
    templateUrl: './view.main.html',
    styleUrls: ['./view.main.css']
})
export class ViewMain { }